import getNewRelicInstance from './getNewRelicInstance';
// Capture a page action, useful for 'INFO' or 'WARN' severity logs
// You can query the log in newRelic using NRQL: SELECT count(*) FROM PageAction
var capturePageAction = function capturePageAction(_ref, attributes) {
  var action = _ref.action,
    location = _ref.location,
    severity = _ref.severity,
    statusCode = _ref.statusCode;
  var statusCodeMessage = statusCode ? "; statusCode: ".concat(statusCode) : '';
  var detailedAction = "message: ".concat(action, "; location: ").concat(location, "; severity: ").concat(severity).concat(statusCodeMessage);
  var nrInstance = getNewRelicInstance();
  nrInstance.addPageAction(detailedAction, attributes);
};
export default capturePageAction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/observability/dist/esm/NewRelicHelpers/capturePageAction.js
// module id = 2623
// module chunks = 11